export default {
  // 단어
  'profile': '프로필',
  'user': '사용자',
  'login': '로그인',
  'logout': '로그아웃',
  'ID': '아이디',
  'ID_email': '아이디 (이메일 형식)',
  'PW': '비밀번호',
  'PW_desc': '영문자, 특수문자, 숫자를 혼합하여 8~12 자리로 입력해주세요',
  'PW_confirm': '비밀번호 확인',
  'PW_confirm_desc': '동일한 비밀번호를 입력해주세요',
  'agreement_view_text': '열람',
  'required_label': '필수',
  'PW_origin':'기존 비밀번호',
  'PW_new':'새 비밀번호',
  'PW_new_confirm':'새 비밀번호 확인',
  'check_email_message':'이메일을 확인해 주세요',
  'check_email_desc':'작성하신 이메일 주소에서 인증확인을 눌러주세요',
  'footer':'Copyright 2025. KOINO Inc. All rights reserved.',
  'SC0010': '신용카드',
  'SC0030': '계좌이체',
  'SC0060': '휴대폰 결제',
  'Superadmin': '서비스',
  'Corporate': '코퍼레이트',
  'LMM100': 'LMM100',
  'LMM300': 'LMM300',
  'LMM500': 'LMM500',
  'LMM1000': 'LMM1000+',
  'LMM1000+': 'LMM1000+',
  'Basic': '베이직',
  'Free': '무료체험',
  'Email': '이메일',
  'name': '이름',
  'phone': '전화번호',
  'office_phone': '사무실 전화',
  'subscription_path': '가입경로',
  'windows': '윈도우',
  'Windows': '윈도우',
  'linux': '리눅스',
  'mac': '맥',
  'android': '안드로이드',
  'agent': '에이전트',
  'remote_device': '원격 기기',
  'download': '다운로드',
  'manual': '메뉴얼',
  'service': '서비스',
  'payment': '결제',
  'manage': '관리',
  'manager': '관리자',
  'group': '그룹',
  'group_info': '그룹 정보',
  'multiple': '다중',
  'information': '정보',
  'threshold': '경고기준',
  'limit': '임계값',
  'alert': '경고',
  'normal': '정상',
  'setting': '설정',
  'device': '원격기기',
  'type': '유형',
  'add': '추가',
  'add_n': '{v} 추가',
  'remove': '제거',
  'delete': '삭제',
  'progress': '진행',
  'time': '시간',
  'hour': '시',
  'minute': '분',
  'second': '초',
  'device-in-group': '그룹에 속한 원격기기',
  'list-of': '{v} 목록',
  'total': '전체',
  'history': '이력',
  'registration': '신청',
  'statistics': '통계',
  'stats': '통계',
  'update': '연장',
  'renew': '갱신',
  'connected': '연결됨',
  'disconnected': '연결끊김',
  'running': '작동중',
  'sub-manager': '하위사용자',
  'execute': '실행',
  'cancel': '취소',
  'ea': '개',
  'WON': '원',
  'months': '개월',
  'years': '년',
  'back': '뒤로',
  'expire': '만료',
  'notify': '알림',
  'help': '도움말',
  'status': '상태',
  'program': '프로그램',
  'homepage': '홈페이지',
  'web': '웹',
  'proposal': '제안서',
  'brochure': '브로셔',
  'ios': 'iOS',
  'etc': '기타',
  'on-work': '준비중',
  'list-view': '리스트',
  'card-view': '아이콘',
  'live-view': '썸네일',
  'delete-n': '{v} 삭제',
  'move-group-n': '그룹이동',
  'selected': '선택된',
  'accessable': '접근가능',
  'empty': '없음',
  'device_limit': '원격기기 최대 등록 수량 제한',
  'device_name': '원격기기 이름',
  'device_name_identical': '같은 원격기기 이름입니다.',
  'device_name_edit': '원격기기 이름 변경',
  'device_name_desc': '원격기기 이름을 <b>{alias}</b>에서 아래와 같이 변경합니다.<br><br>[변경 원격기기 이름 입력]',
  'device_name_confirm': '원격기기 이름이 <b>{alias}</b>에서<br><b>{value}</b>으로 변경됩니다.',
  // MDM 기기정책(구성) 적용
  'mdm_config': '구성',
  'mdm_config_unassigned': '미할당',
  'mdm_apply_config': '원격기기 구성 변경',
  'device_location_map': '원격기기 위치 보기',
  'map_search_placeholder': '기기 검색',
  'map_select_all': '전체 선택',
  'map_shown_count': '{count}대 표시',
  'map_empty': '위치가 보고된 온라인 기기가 없습니다.',
  'mdm_change_config': '구성 변경',
  'mdm_apply_config_desc': '선택한 원격기기에 적용할 구성을 선택하세요. 구성의 OS와 일치하는 기기에만 적용됩니다.',
  'mdm_apply_config_placeholder': '구성 선택',
  'mdm_apply_summary': '적용 {apply}대 · 제외 {skip}대',
  'mdm_apply_skip_reason': '이미 동일 {same} · OS 불일치 {os}',
  'mdm_apply_target': '적용 대상 기기',
  'mdm_apply_target_count': '{count}대',
  'mdm_config_current_applied': '(현재 적용됨)',
  'mdm_os_unsupported': '미지원',
  'mdm_apply_none': '선택한 구성을 적용할 수 있는 기기가 없습니다.',
  'mdm_apply_done': '구성 적용 완료 ({success}대)',
  'mdm_apply_done_excluded': '구성 적용 완료 (적용 {success}대 · 제외 {excluded}대)',
  'mdm_status_applied': '적용됨',
  'mdm_status_pending': '대기',
  'mdm_status_failed': '실패',
  'O/S': 'O/S',
  'edit': '편집',
  'refresh': '새로고침',
  'off-editmode': '편집모드 종료',
  'emptied_memo': '-',
  'upper_group': '상위그룹',
  'all_device': '모든 원격기기',
  'submit': '확인',
  'create': '생성',
  'delete_group': '그룹삭제',
  'delete_device': '원격기기 삭제',
  'device_logoff': '원격기기 로그오프',
  'favorate': '즐겨찾기',
  'search': '검색',
  'by_user': '사용자별 {v}',
  'by_device': '원격기기별 {v}',
  'by_type': '유형별 {v}',
  'by_daily': '일별',
  'by_monthly': '월별',
  'alert_count': '경고 발생 횟수',
  'use_rate': '사용률',
  'rate': '비율',
  'use_count': '횟수',
  'select_date': '기간선택',
  'connect_count_of_remote': '원격제어 시도 횟수 추이',
  'count_of_alert': '경고 발생 횟수 추이',
  'chart': '차트',
  'date': '날짜',
  'host': '호스트',
  'viewer': '뷰어',
  'at_time': '일시',
  'start_time': '시작 시간',
  'end_time': '종료 시간',
  'start_date': '시작일',
  'expire_date': '만료일',
  'event_time': '발생 시간',
  'login_time': '접속 시간',
  'delete_time': '삭제 시간',
  'payment_date': '결제일',
  'type_of_device': '원격기기 유형',
  'alert_message': '경고메세지',
  'browser': '브라우저',
  'file_name': '파일이름',
  'size': '크기',
  'top10': '상위10',
  'change': '변경',
  'do_change': '변경하기',
  'advenced_auth': '2단계 인증(OTP)',
  'department': '부서',
  'cowork_position': '직책',
  'timezone': '표준시간대',
  'date_format': '@:date 형식',
  'time_sec': '시간(초)',
  'auto_update': '자동갱신',
  'active': '활성화',
  'inactive': '비활성화',
  'permission': '권한',
  'target': '대상',
  'common': '공통',
  'web_manager': '웹매니저',
  'CS_manager': 'CS매니저',
  'empty_manager': '@:manager @:empty',
  'empty_phone': '@:phone @:empty',
  'empty_Email': '@:Email @:empty',
  'license': '라이선스',
  'regist_service': '@:license 추가',
  'update_service': '@:service 갱신',
  'device_type': '제품유형',
  'device_vol': '원격기기 수',
  'exceed_device_vol': '초과 원격기기 수',
  'remain': '남은 기간',
  'period': '기간',
  'price': '가격',
  'total_price': '총 금액',
  'payment_type': '제품유형',
  'payment_method': '결제수단',
  'remark': '비고',
  'notice': '공지사항',
  'cs_center': '고객센터',
  'cs_phone': '02-6949-0488, 070-7126-8663',
  'save': '저장',
  'find_n': '{v} 찾기',
  'check_n': '{v} 확인',
  'signup': '회원가입',
  'trial': '무료체험하기',
  'use_for': '가입 구분',
  'personal': '개인',
  'enterprise': '기업',
  'company': '회사',
  'continue': '계속',
  'temperature': '온도',
  'speed': '속도',
  'running_time': '러닝 타임',
  'system_time': '시스템 시간',
  'version': '버전',
  'access_log': '접근/제어 이력',
  'list_of_process': '프로세스 목록',
  'list_of_hardware': '하드웨어 목록',
  'list_of_software': '소프트웨어 목록',
  'enter_n': '{v} 입력',
  'reset_n': '{v} 재설정',
  'authorization': '본인 인증',
  'send_n': '{v} 보내기',
  'resend_n': '{v} 재전송',
  'close': '닫기',
  'secure': '보안',
  'available_count': '사용가능 원격기기',
  'submanager-right': '부서장 권한',
  'access-registration-history': '원격기기 원격제어 접근신청 내역',
  'access-num': '일련번호',
  'device-name': '원격기기명',
  'device-ip': '원격기기 아이피',
  'application-date': '접수시간',
  'application-period': '신청기간',
  'approver': '승인자',
  'applicant': '신청자',
  'approval-status': '승인여부',
  'approval': '승인',
  'approval-ing': '진행중',
  'function-settings': '정책관리',
  'function-settings01': '로그인 실패 계정 잠금 횟수(회)',
  'function-settings02': '원격접속 유휴시간(분)',
  'function-settings03': '파일전송',
  'blocking-settings': '접속 IP 관리',
  'blocking-settings01': '차단/허용 정책',
  'approval-submit-user': '재신청',
  'blocking-super-settings': '정책사용',
  'reset-pw': '초기화',
  'reject-submit': '반려',
  'reject': '거부',
  'security-access': '동의',
  'manager-id': '관리자',
  'sub-manager-id': '중간관리자',
  'reject-access': '승인취소',
  'request-agent': '원격기기',
  'request-date': '신청기간',
  'request-reason': '사유',
  'approval-reason': '부서장의견',
  'security-access-title':'보안서약서 동의',
  'excel-form':'Excel 양식 다운로드',
  'approval-apply':'승인프로세스 적용',
  'user-in-group':'그룹 접근 권한 사용자',
  'deleted-device-edit':'수정',
  'request-history':'접근신청 내역',
  'approval-process':'접근신청 승인',
  'approval-process-history':'접근신청 승인내역',
  'major-os-version':'메이저OS 버전',
  'minor-os-version':'마이너OS 버전',
  'session-time':'원격접속 유지시간(분)',
  'account_security' : '계정보안',
  'password_level' : '비밀번호 난이도 설정',
  'password_level0' : '제한 없음 (4자리 ~ 12자리)',
  'password_level1' : '영문 + 숫자 (6자리 ~ 12자리) 이내로 입력하세요.',
  'password_level2' : '영문 + 숫자 + 특수문자 (8자리 ~ 12자리) 이내로 입력하세요.',
  'password_level3' : '대문자 영문 + 소문자 영문 + 숫자 + 특수문자 (8자리 ~ 12자리) 이내로 입력하세요.',
  'self_unlock' : '잠금 계정 자가 해제 허용',
  'vaccine':'프로세스/서비스명 감지',
  'capture':'화면 캡쳐 및 녹화',
  'display-power-save':'화면 절전 방지',
  'system-power-save':'시스템 절전 방지',
  'security-agreement':'보안서약서 사용',
  'remote-policy':'원격 기능 정책',
  'user-connection-policy':'사용자 접속 환경 정책',
  'os-version':'Windows OS 버전 허용',
  'blocking-settings-ip-list':'접속 IP 목록',
  'single-ip':'IP 단일주소',
  'reason':'사유',
  'range-ip-start':'시작 주소',
  'range-ip-end':'끝 주소',
  'subnet-ip':'서브넷팅 주소',
  'time-added':'적용시간',
  'ip-address':'IP 주소',
  'password-expired':'비밀번호 최대사용기간(일)',
  'excel-users': '사용자 일괄 등록',
  'enrollment': '등록',
  'excel-groups': '그룹 일괄 등록',
  'account-manage':'사용자',
  'all-devices':'원격기기',
  'tutorial':'튜토리얼',
  'device-drop-all':'모든 PC',
  'service-payment-history':'서비스 결제내역',
  'tutorial-device':'처음 사용하시나요? (원격지 PC 추가하는 방법 보기)',
  'tutorial-group':'그룹관리 안내가 필요하신가요? (그룹관리 기능 보기)',
  'tutorial-manager':'사용자 계정이 뭔가요? (계정관리 기능 보기)',
  'tutorial-statistics':'통계/이력에서 제공하는 기능은 무엇인가요? (통계/이력 기능 보기)',
  'tutorial-top10':'그룹관리 안내가 필요하신가요? (그룹관리 기능 보기)',
  'tutorial-download':'원격기기 다운로드 및 설치 가이드',
  'tutorial-license':'전자결제가 안되시나요?',
  'first-add-device':'원격지 PC 추가',
  'download_remote_device':'에이전트 설치',

  // 메세지
  'no-selects': '선택된 항목이 없습니다.',
  'no-content': '해당되는 항목이 없습니다',
  'no-agent': '등록된 원격기기가 없습니다. 원격지 PC를 추가해주세요.',
  'on_working': '준비중 입니다.',
  'has_new_message': '새로운 알림이 있습니다',
  'not_save_warning': '저장하지 않는 내용은 반영되지 않습니다. 진행하시겠습니까?',
  'not_online_warning': '원격기기가 온라인 상태가 아닙니다.',
  'no_input_data': '입력한 내용이 없습니다.',
  'add_child_group': '"{name}"의 하위 그룹을 추가합니다.<br>그룹 이름을 입력해주세요.',
  'add_root_group': '"최상위"에 그룹을 추가합니다.<br>그룹 이름을 입력해주세요.',
  'duplication_group_name': '같은 이름의 그룹이 같은 위치에 있습니다.',
  'created_group': '그룹을 생성했습니다.',
  'please_select_group': '그룹을 선택해 주세요.',
  'identical_group': '동일한 원격기기 그룹으로 그룹 이동을 시도하셨습니다. 다른 원격기기 그룹을 선택하여 주십시오.',
  'confirm_delete_group': '그룹 삭제 시, 해당 그룹의 기기는 기본그룹으로 이동합니다.<br>삭제하시겠습니까?',
  'deleted_group': '그룹이 삭제되었습니다.',
  'all_device_has_no_child': '모든원격기기에 하위그룹을 포함할 수 없습니다.',
  'confirm_delete_device': `
    등록된 원격기기를 삭제합니다.<br>
    삭제된 원격기기를 다시 연결하려면 원격지에서 로그인이 필요합니다.<br>
    <br>
    <h6 class="delete-target">{name}</h6>
  `,
  'confirm_device_logoff': '등록된 원격기기를 로그오프합니다.',
  'access-ticket': '제어권 신청',
  'ticket-request': '제어권 신청 관리',
  'at.requested': '승인요청중',
  'at.re-requested': '재승인요청중',
  'at.approved': '승인완료',
  'at.on-work': '작업중',
  'at.reject': '반려됨',
  'at.completed': '종료',
  'at.Unknown': '알수없는상태',
  'has_request_ticket': '{count}개의 제어권 신청이 있습니다',
  'deleted_device': '원격기기가 삭제되었습니다.',
  'moved_device': '[{device}]이(가) [{group}]으로 이동하였습니다.',
  'moved_device_by': '[{device}]이(가) [{group}] 옆으로 이동하였습니다.',
  'moved_device_fail': '{name}은(는) 옮길 수 없습니다.',
  'deleted_device_count': '[{count}/{total}] 원격기기가 삭제되었습니다.',
  'no_order_warning': '그룹 순서 이동은 지원하지 않습니다. 오름차순으로 정렬됩니다',
  'delete_user_confirm': '해당 사용자를 삭제 하시겠습니까?',
  'delete_group_confirm': '해당 그룹을 삭제 하시겠습니까?',
  'delete_checked_user_confirm': '선택한 사용자를 정말 삭제하시겠습니까?',
  'user_active_changed': '"{name}"이(가) "{status}"로 변경되었습니다.',
  'deleted_user': '사용자가 삭제되었습니다.',
  'created_user': '사용자가 등록되었습니다.',
  'updated_memo': '메모가 수정되었습니다.',
  'update_agent_requested': '업데이트가 요청되었습니다.',
  'update_agent_desc': '원격지 기기의 원격기기 프로그램을 업데이트 합니다. <br>현재 버전: {current_ver} > 최신 버전: {latest_ver}',
  'delete_threshold': '해당 경고기준을 삭제하시겠습니까?',
  'no_perm_group': '이 그룹에 대한 권한이 없습니다.',
  'add_permission_of_group': `
    이 그룹의 권한을 부여하기 위해 아래의 상위그룹에 대한 권한이 필요합니다.
    <br><br>
    [{groups}]
    <br><br>
    허용하시겠습니까?
  `,
  'delete_permission_of_group': `
    이 그룹의 권한을 제거하기 위해 아래의 하위그룹에 대한 권한제거가 필요합니다.
    <br><br>
    [{groups}]
    <br><br>
    허용하시겠습니까?
  `,
  'please_select': '선택해 주세요.',
  'please_input': '입력해 주세요.',
  'please_select_device_type': '원격기기유형을 @:please_select',
  'please_select_alert_type': '경고 유형을 @:please_select',
  'please_input_alert_time': '진행 시간을 @:please_input',
  'please_input_alert_value': '임계값을 @:please_input',
  'please_input_memo': '메모를 @:please_input',
  'permissions': {
    'deviceMonitor': '원격기기 모니터링',
    'CSRemoteControl': '원격 제어',
    'CSFileManager': '파일 전송',
    'modifyInformation': '정보 수정',
    'useFunction': 'PC재시작/종료/삭제',
    'viewReport': '통계/이력 보기',
    'CSRemoteView': '원격 보기',
    'CSDeviceManagement': '원격기기 이름수정/삭제',
    'CSUpdate': '원격기기 업데이트',
    'CSThumbnailView': '썸네일 뷰',
    'CSRestart': 'PC재시작'
  },
  'getin_with': {
    'internet_search': '인터넷 검색',
    'recommendation': '지인 추천',
    'advertising': '광고/신문/매체',
    'sns': 'SNS/블로그',
    'pcany': '피씨애니 유료 고객',
    'etc': '기타'
  },
  'added_device_in_group': '원격기기가 그룹에서 추가되었습니다.',
  'removed_device_in_group': '원격기기가 그룹에서 제거되었습니다.',
  'changed_group_info': '그룹정보가 변경되었습니다.',
  'remote': {
    'remote': {
      'title': '원격제어',
      'title2': '원격제어',
      'desc': '원격기기 연결을 시작합니다.',
      'desc_mac': '원격제어를 시작 하시겠습니까?<br>(첫 실행시 프로그램을 먼저 설치해 주세요)',
      'activex': '잠시 후 런처가 실행됩니다.',
      'activex_error': 'ActiveX 실행에 실패했습니다.',
      'download': '런처가 다운로드되면 실행해 주세요.',
      'launch': '잠시 후 런처가 실행됩니다. 미설치 시 설치 파일이 다운로드됩니다.',
      'application': '잠시 후 앱 런처가 실행됩니다.',
      'error': '런처 실행에 실패하였습니다.',
      'urlscheme': '잠시 후 프로그램이 실행됩니다'
    },
    'transfer': {
      'title': '파일전송',
      'desc': '파일전송를 시작 하시겠습니까?',
      'activex': '잠시 후 런처가 실행됩니다.',
      'activex_error': 'ActiveX 실행에 실패했습니다.',
      'download': '런처가 다운로드되면 실행해 주세요.',
      'launch': '잠시 후 런처가 실행됩니다. 미설치 시 설치 파일이 다운로드됩니다.'
    },
    'reboot': {
      'title': '시스템 재시작',
      'desc': '※ 해당 원격기기 자동실행 / 로그인 기능이 꺼져있는 경우 원격 연결이 불가합니다.  원격기기를 재시작 하시겠습니까?',
      'requested': '재부팅이 요청되었습니다.'
    },
    'restart': {
      'title': '원격기기 재시작',
      'desc': '원격기기 프로그램을 재시작 합니다.',
      'requested': '원격기기 재시작이 요청되었습니다.'
    },
    'shutdown': {
      'title': '시스템 종료',
      'desc': '※ 시스템이 종료되는 경우 오프라인 상태로 전환되어 원격 연결이 불가합니다.  원격기기의 시스템을 종료 하시겠습니까?',
      'requested': '시스템 종료가 요청되었습니다.'
    },
    'preview': {
      'title': '스크린샷'
    },
    'detail': {
      'title': '상세정보'
    },
    'logoff': {
      'title': '원격기기 로그오프'
    },
    'delete': {
      'title': '원격기기 삭제'
    },
    'wol': {
      'title': 'WOL 전원켜기',
      'desc': '"{device}" 장비를 하기 장비를 통하여 WOL로 켭니다. 장비를 선택하여 주십시오.',
      'success': 'WOL 신호를 전송했습니다.'
    },
    'approve' : {
      'title': '제어권없음',
      'desc': '원격신청'
    },
    'web': {
      'title': '원격제어(웹뷰어)'
    },
    'normal' : {
      'title': '원격제어(노멀뷰어)'
    }
  },
  'columns': {
    'alive': '상태',
    'actions': '기능',
    'alias': '원격기기 이름',
    'memo': '메모',
    'last_connected_time': '원격기기 로그인일시',
    'group': '그룹',
    'connect': '접속'
  },
  'id_exist': '이미 존재하는 아이디입니다.',
  'reserved': {
    'ROOT': '기본그룹'
  },
  'audit-message': {
    '1': '원격제어 기능을 수행하였습니다.',
    '2': '파일관리자 기능을 수행하였습니다.',
    '3': '시스템을 재시작하였습니다.',
    '4': '시스템을 종료하였습니다.',
    '5': '원격기기를 최신버전으로 업데이트 하였습니다.',
    '11': '원격기기의 이름을 \'{old_value}\'에서 \'{new_value}\'로 변경하였습니다.',
    '12': '원격기기의 메모를 \'{old_value}\'에서 \'{new_value}\'로 변경하였습니다.',
    '21': '\'{old_value}\'에서 \'{new_value}\'로 그룹을 이동하였습니다.',
    '30': '{old_value} 에서 {new_value} 로 변경하였습니다.',
    '31': '예약(켜기) : {new_value}을 추가하였습니다.',
    '32': '예약(끄기) : {new_value}을 추가하였습니다.',
    '33': '예약(켜기) : {new_value}번째 설정을 제거 하였습니다.',
    '34': '예약(끄기) : {new_value}번째 설정을 제거 하였습니다.',
    '35': '리모컨 : {new_value} 실행하였습니다.'
  },
  'response_error_server_error': '데이터를 불러오는 중 일시적인 오류가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
  'response_error_connect_failed': '서버에 연결할 수 없습니다. 잠시 후 다시 시도해 주세요.',
  'not_supported_os': '지원하지 않는 운영체제입니다.',
  'alert_license': '라이센스 만료 알림',
  'need_license': '{v} 라이센스가 필요합니다.',
  'invalid_id_and_pw': '아이디와 비밀번호를 확인해 주세요.',
  'login_failed_cause_step1': '아이디와 비밀번호를 확인해 주세요.',
  'login_failed_cause_step2': '이메일 인증이 이루어지지 않았습니다.<br>인증메일을 못받으신 분들은 인증메일 재전송 버튼을 눌러주시기 바랍니다.',
  'login_failed_cause_flag_active': '계정이 비활성화 됐습니다.<br>담당자에게 문의해 주세요.',
  'login_failed_cause_superadmin': '외부접속은 제한되어 있습니다.',
  'invalid_id': '올바른 아이디를 입력해 주세요',
  'invalid_otp': 'OTP 인증암호가 잘못되었습니다. 다시 입력해주세요.',
  'otp_token_expired': 'OTP 인증 시간이 만료되었습니다. 다시 로그인해주세요.',
  'name_requirement': '이름을 입력해 주세요.',
  'phone_requirement': '전화번호를 입력해 주세요',
  'emile_requirement': '이메일 형식으로 입력해 주세요',
  'subspath_requirement': '가입경로를 입력해 주세요',
  'company_name_requirement': '회사이름을 입력해 주세요',
  'digit_n_requirement': '디지털 숫자 {v}개를 입력하세요',
  'dont_show_again': '더 이상 보지않기', // 'Don\'t show again'
  'signup_done': '회원가입 완료',
  'free_trial_message': '<strong>기기 1대 15일간 무료</strong>지금부터 원격제어 LinkMeMine를<br>마음껏 이용해 보세요.',
  'enter_old_password': '현재 비밀번호 입력',
  'enter_new_password': '새 비밀번호 입력',
  'search_location': '지역이름을 검색하세요',
  'accessable_user_desc': '해당 그룹의 원격기기 접근 권한이 있는 하위 사용자 목록입니다.',
  'password_requirement': '비밀번호는 영문자, 특수문자, 숫자를 혼합하여 8~12자리 이내로 입력하세요.',
  'password_confirm': '비밀번호가 일치하지 않습니다.',
  'password_modify_mail_sent': '비밀번호 변경 이메일이 발송되었습니다.',
  'password_modified': '비밀번호가 변경되었습니다.',
  'password_modified_failed': '비밀번호 변경이 실패하였습니다.',
  'otp_reset_complete': 'OTP가 초기화 되었습니다.',
  'otp_reset_failed': 'OTP가 초기화에 실패하였습니다.',
  'password_reset_desc': '비밀번호를 재설정하시기 바랍니다.',
  'forgot_desc': '아이디 찾기 또는 비밀번호 찾기를 통해 해결이 불가능하시다면<br>' +
    '고객센터로 메일 문의주시기 바랍니다.<br>' +
    '\'문의하기\'를 통해 문의하기 페이지로 이동하시거나' +
    '<br>Support@linkmemine.com 으로 메일 문의 부탁드립니다.',
  'expired_desc': '계속 이용하시려면 기존 라이센스를 갱신 하시거나<br>삭제 할 디바이스를 선택 해 주시기 바랍니다.',
  'expired_user_desc': '라이선스가 만료되어 사용하실 수 없습니다.<br>관리자를 통해 라이선스를 갱신하거나 초과되는 원격기기를 삭제하셔야 합니다.',
  'email-invalid': '정확한 이메일을 입력해 주세요',
  'id-invalid': '정확한 아이디를 입력해 주세요',
  'navigate_to_home': '홈으로 이동',
  'email_verification_success': '이메일 인증 성공',
  'email_already_verified': '이미 인증된 이메일',
  'email_verification_failed': '이메일 인증 실패',
  'email_verification_pending': '인증 처리 중...',
  'email-auth-wait': '이메일 인증을 하고 있습니다.<br>잠시만 기다려 주세요',
  'email-auth-already': '이메일 인증이 이미 완료되었습니다',
  'email-auth-fail': '이메일 인증에 실패하였습니다',
  'email-auth-success': '이메일 인증을 성공하였습니다.<br>로그인하여 주시기 바랍니다.',
  'login_description': '고객님이 가지고 있는 모든 PC나 스마트 기기, IoT 장비에 접속할 수 있습니다',
  'join_description': '링크미마인 회원가입을 환영합니다.<br>회원 가입 이후 등록하신 이메일로 발송된 메일 인증 후 사용해주세요.',
  'go_login': '로그인하러가기',
  'your_email_is': '해당 아이디는 등록된 아이디입니다.',
  'not_matched_user': '일치하는 사용자가 없습니다.',
  'is_pcany_customer': '현재 피씨애니의 유료 고객이십니까?',
  'add_manager_desc': `
    <div>1. 하위 사용자 계정은 별도의 이메일 인증 없이 생성 후 바로 사용이 가능합니다..</div>
    <div>2. 하위 사용자 계정으로 로그인한 원격기기는 관리자 계정에 귀속되여 보여집니다.</div>
    <div>3. 각 하위 사용자에 대한 권한 설정 및 접근 가능 원격기기 그룹 설정이 가능합니다.</div>
  `,
  'free_trial_comment': '무료체험 중 입니다. 서비스를 연장해 주세요.',
  'secure_login_desc': '만약 보안코드 6자리를 확인할 수 없다면<br>고객센터로 연락주시기 바랍니다.',
  'payment_tax_desc1': '메일문의 : support@linkmemine.com',
  'payment_tax_desc2': '전자결제문의 : 1544-7772(토스페이먼츠)',
  'payment_tax_desc3': '문의처 : 고객 지원 02-839-7500(2번)<br>support@linkmemine.com',
  'payment_tax_desc4': '에이전트 수량 및 제품유형을 변경하시려면 라이선스 추가 버튼을 눌러 신청하셔야 합니다.',
  'not_email_auth': '인증 메일을 발송하였습니다.<br>메일을 확인해주세요.',
  'email_send_fail': '이메일 발송이 실패했습니다. 이메일 주소를 확인해 주세요',
  'mobile_store': `
    모바일 원격제어는<br>
    어플리케이션을 이용해주세요.<br><br>
    <a href="{url}" target="_blank">스토어로 바로가기</a>
  `,
  'OTP_desc': '웹매니저 로그인 시 Google OTP로 2단계 인증을 진행합니다',
  'agreement': {
    'desc': '이용약관과 개인정보 수집/이용에 대한 동의를 해주세요.',
    'agree_all': '모두 동의 합니다',
    'agree_use': '이용약관 동의',
    'agree_use_context': `
      [서비스 이용약관]

      제1조 (목적)
      본 약관은 (주)링크미마인이 운영하는 웹사이트(linkmemine.com)에서 제공하는 서비스 이용과 관련하여, 링크미마인과 이용자 간의 권리·의무 및 책임사항을 정함을 목적으로 합니다.
      
      제2조 (정의)
      1. "링크미마인 서비스"란 유용한 정보를 제공하는 웹사이트 및 관련 서비스를 의미하며, 운영 주체로서의 링크미마인도 포함합니다.
      2. "서비스"란 사이트를 통해 제공되는 유·무형의 유·무료 콘텐츠 및 행위를 의미합니다.
      3. "이용자"는 링크미마인 서비스를 이용하는 모든 회원 및 비회원을 말합니다.
      4. "회원"은 ID 등록을 통해 지속적으로 서비스를 이용할 수 있는 자입니다.
      5. "비회원"은 회원에 해당하지 않는 이용자를 말합니다.
      
      제3조 (약관의 명시 및 개정)
      - 본 약관은 홈페이지 초기 화면에 게시됩니다.
      - 관련 법령에 따라 개정 가능하며, 개정 시 적용일자와 사유를 명시하여 7일 전부터 공지합니다.
      - 개정 약관은 공지일 이후 체결된 계약부터 적용되며, 기존 계약에는 기존 약관이 적용됩니다.
      - 회원은 변경된 약관에 동의하지 않을 경우 탈퇴할 수 있습니다.
      - 일정 기간 서비스 이용 시, 약관 동의로 간주될 수 있습니다.
      
      제4조 (서비스 제공 및 변경)
      1. 링크미마인은 아래 서비스를 제공합니다.
         - 프로그램 및 앱 정보 제공
         - 광고 및 이벤트
         - 기타 유용한 부가 서비스 등
      2. 품절이나 기술 변경 시, 서비스 내용을 사전 공지 후 변경할 수 있습니다.
      3. 링크미마인의 고의·과실이 없는 경우, 서비스 변경으로 인한 손해에 대한 책임은 지지 않습니다.
      
      제5조 (서비스 중단)
      - 시스템 점검, 고장, 통신 장애 등으로 서비스가 일시 중단될 수 있습니다.
      - 중단 시 제8조에 따른 통지 방식으로 안내합니다.
      - 단, 링크미마인의 고의·과실이 없는 경우 손해 배상 책임은 없습니다.
      
      제6조 (회원가입)
      - 가입은 무료이며, 이메일 인증 후 회원이 됩니다.
      - 허위정보 기재 또는 서비스 운영에 지장을 주는 경우 가입이 거부될 수 있습니다.
      - 회원은 정보 변경 시 즉시 수정해야 합니다.
      
      제7조 (회원 탈퇴 및 자격상실)
      - 회원은 언제든 탈퇴를 요청할 수 있습니다.
      - 다음 사유 시 자격이 제한 또는 박탈될 수 있습니다.
        1. 허위 등록
        2. 결제 미이행
        3. 개인정보 도용
        4. 명예 훼손 또는 서비스 방해
        5. 음란물 게시
        6. 불법 행위
        7. 고의적 운영 방해
      - 자격 상실 전 소명 기회가 주어집니다.
      
      제8조 (회원 통지)
      - 회원에게는 등록된 이메일로 개별 통지합니다.
      - 다수 회원에게는 1주일 이상 게시판에 공지할 수 있습니다.
      
      제9조 (사이트 간 약관 적용)
      - 링크미마인 산하의 각 사이트 이용 시, 해당 사이트 약관이 적용됩니다.
      
      제10조 (개인정보 보호)
      - 필수 정보 외에는 선택 사항입니다.
      - 수집 시 동의를 얻고, 제3자 제공 시에도 별도 동의를 받습니다.
      - 목적 외 사용 금지, 이용자 열람·수정 가능, 목적 달성 후 파기 등의 조치를 취합니다.
      - 개인정보관리책임자: support@linkmemine.com
      
      제11조 (링크미마인의 의무)
      - 안정적인 서비스 제공, 보안 시스템 구축
      - 부당 광고로 인한 손해 시 배상
      - 광고성 메일 거절 의사 표시 시, 더 이상 발송하지 않음
      
      제12조 (ID 및 비밀번호 관리)
      - ID·비밀번호 관리는 회원 책임입니다.
      - 제3자에게 공유 금지, 도용 시 즉시 신고
      
      제13조 (이용자의 의무)
      다음 행위를 금합니다.
      1. 허위 등록
      2. 게시 정보 무단 변경
      3. 허가받지 않은 프로그램 송신
      4. 타인의 지적재산권 침해
      5. 타인 명예 훼손 및 업무 방해
      6. 음란 또는 폭력 정보 게시
      
      제14조 (연결 사이트와의 관계)
      - 연결된 웹사이트의 재화·용역 거래에 대해 링크미마인은 책임지지 않습니다.
      
      제15조 (저작권)
      - 링크미마인이 작성한 콘텐츠의 지적재산권은 링크미마인에 귀속됩니다.
      - 사전 동의 없이 영리 목적의 이용 금지
      
      제16조 (면책사항)
      - 천재지변 등 불가항력, 이용자 과실, 수익 미달, 제3자 게시물 등에 대해서는 책임지지 않습니다.
      
      제17조 (광고 게재)
      - 광고 게재 및 DM 발송 가능 (거부 시 중단)
      - 회원의 광고 참여로 발생한 손해는 책임지지 않습니다.
      
      제18조 (분쟁 해결)
      - 피해 보상처리기구 운영
      - 불만사항은 우선 처리하며, 지연 시 사유 안내
      - 필요 시 전자거래분쟁조정위원회 조정에 따를 수 있음
      
      제19조 (재판권 및 준거법)
      - 소송은 민사소송법상 관할법원에 제기
      - 준거법은 대한민국 법
      
      부칙
      - 본 약관은 2016년 4월 1일부터 시행합니다.
    `,
    'agree_privacy': '개인정보 수집/이용에 대한 동의',
    'agree_privacy_context': `
      [링크미마인 개인정보 수집/이용에 대한 동의] 

      1. 수집하는 개인정보의 항목
      2. 개인정보의 수집 별 이용목적
      3. 개인정보의 보유 및 이용기간
      
      
      1. 수집하는 개인정보의 항목
      '사이트'는 회원가입 절차 없이 이용하실 수 있는 컨텐츠와 원격지원을 위한 서비스 가입 후에 이용하실 수 있는 컨텐츠로 구성되어 있습니다.
      '사이트'의 회원제 서비스를 이용하시고자 할 경우 다음의 정보를 입력해주셔야 하며 선택항목을 입력하시지 않았다 하여 서비스 이용에 제한은 없습니다.
      1) 회원가입 시 수집하는 개인정보의 범위
      - 아이디(이메일), 이름, 전화번호, 생년월일, 메일수신여부
      
      
      
      2. 개인정보의 수집 별 이용목적
      ① '사이트'는 다음과 같은 목적을 위하여 개인정보를 수집하고 있습니다
      - 성명, 아이디, 비밀번호 : 회원제 서비스 이용에 따른 본인 식별 절차에 이용
      - 이메일주소, 전화번호 : 고지사항 전달, 본인 의사 확인, 불만 처리 등 원활한 의사소통 경로의 확보, 새로운 서비스, 신상품이나 이벤트 정보 등 최신 정보의 안내
      - 그 외 선택항목(생년월일 등) : 개인맞춤 서비스를 제공하기 위한 자료
      
      ② 단, 이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보 (인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않습니다.
      
      
      3. 개인정보의 보유 및 이용기간
      
      ① 귀하의 개인정보는 다음과 같이 개인정보의 수집목적 또는 제공받은 목적이 달성되면 파기됩니다.
      단, 상법 등 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 예외로 합니다.
      - 회원가입정보의 경우, 회원가입을 탈퇴하거나 회원에서 제명된 때
      - 대금지급정보의 경우, 대금의 완제일 또는 채권소멸시효기간이 만료된 때
      
      ② 위 개인정보 수집목적 달성시 즉시파기 원칙에도 불구하고 다음과 같이 거래 관련 권리 의무 관계의 확인 등을 이유로 일정기간 보유하여야 할 필요가 있을 경우에는 전자상거래등에서의소비자보호에관한법률등에 근거하여 일정기간 보유합니다.
      - 계약 또는 청약철회 등에 관한 기록 : 5년
      - 대금결제 및 재화등의 공급에 관한 기록 : 5년
      - 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년
      
      ③ 귀하의 동의를 받아 보유하고 있는 거래정보등을 귀하께서 열람을 요구하는 경우 '사이트'는 열람, 확인 할 수 있도록 조치합니다.
    `
  },
  'help_otp':`
    <h5>Google OTP를 이용한 2단계 인증설정</h5>
    <section style="margin:30px 0;">
      <h6>1. 2단계 인증(OTP)를 활성화</h6>
      <p style="margin-left: 12px;">활성화 버튼을 클릭하여 녹색으로 활성화 시킵니다.<br>
      OTP 재설정 버튼을 클릭합니다.</p>
    </section>
    <section style="margin:30px 0;">
      <h6>2. Google Play Store, 애플 App Store에서 "Google OTP"를 설치합니다.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>3. Google OTP를 실행합니다.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>4. 링크미마인 관리자 로그아웃 후 다시 로그인 시도를 하면 Google OTP 등록창이 나타납니다.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>5. Google OTP 앱에서 바코드 스캔을 선택하여 등록합니다.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>6. 인증번호 6자리를 입력 후 로그인합니다.</h6>
    </section>`,
  'help_manager': `
    <h5>중간관리자 권한이란?</h5><br>
    <b>중간관리자(승인자)</b> : 사용자 권한을 포함하고, 사용자의 원격제어 승인요청을 허가/거절할 수 있는 권한<br><br>
    <b>사용자(요청자)</b> : 관리자 또는 중간관리자로부터 원격제어 권한을 승인받아 원격기기를 원격제어 및 모니터링 할 수 있는 권한
  `,
  'help_vaccine': `
    <h5>프로세스/서비스 도움말</h5><br>
    <h6>
      설정한 프로세스/서비스 명(.exe 제외)을 <br>입력하세요.
    </h6>
    <h6 style="padding:0 0 20px 0;">(프로세스/서비스 미사용시 빈칸입력)</h6>
  `,
  'help_os': `
    <h5>OS버전 도움말</h5><br>
    <h6 style="padding:0 0 20px 0;">
      사용하실 OS의 버전을 아래에서 확인 후 입력하세요.<br>
    </h6>
    <table>
      <th>OS</th>
      <th style="padding-right:20px;">MajorVersion</th>
      <th>MinorVersion</th>
      <tr>
        <td>Window Server 2019</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window 10</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Server 2016</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Server 2012 R2</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">3</td>
      </tr>
      <tr>
        <td>Window 8.1</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">3</td>
      </tr>
      <tr>
        <td>Window 8</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window Server 2012</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window 7</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window Server 2008 R2</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window Server 2008</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Vista</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Home Server</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window Server 2003</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window XP Professional x64 Edition</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window XP</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window 2000</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">0</td>
      </tr>
    </table>
  `,
  'help_email': `
    <h5>Email & 전화번호, 반드시 입력하는 이유는?</h5><br>
    <div style="margin-left: 12px;">1. 아이디 및 비밀번호 찾기</div>
    <div style="margin-left: 12px;">2. 휴면 및 잠김 계정 해제</div><br>
    기능을 활용하기 위해 필요합니다.
  `,
  'help_searchPW': `
    등록된 이메일 주소로 비밀번호 재설정 메일이 발송됩니다.
  `,
  'ip_delete_all_warning':'아이피리스트를 전체 삭제하시겠습니까?',
  'ip_delete_all':'IP 전체삭제',
  'ip_block_reject':`차단정책에 의해 차단된 IP입니다.<br>관리자에게 문의하세요.`,
  'ip_white_reject':`허용정책에 의해 차단된 IP입니다.<br>관리자에게 문의하세요.`,
  'search_manager_200':`승인자가 설정되었습니다.`,
  'search_manager_405':`승인자의 아이디를 확인해주세요.`,
  'search_approver_null':'빈칸입력시 관리자가 승인자로 자동설정됩니다.',
  'date_validate_error':'신청날짜를 확인해주세요.',
  'approvals_reason':'신청사유를 입력하세요',
  'search_approver_placeholder':'승인자 ID를 입력하세요',
  'approval-success': `
    접근권한 요청이 처리되었습니다.
  `,
  'function-settings-desc01': '중간관리자 및 사용자 파일 전송 기능을 허용/차단합니다.',
  'blocking-settings-desc01': '차단 IP를 등록하여 접속을 차단합니다.',
  'blocking-settings-desc02': '허용 IP를 등록하여 등록된 IP만 접속을 허용합니다.',
  'function-submit': '기능설정이 수정되었습니다.',
  'blocking-submit': '차단/허용 설정이 수정되었습니다.',
  'blocking-super-settings-desc': '접속 IP 관리 설정을 사용합니다.',
  'reset-pw-repeat': '비밀번호를 초기화 하시겠습니까?',
  'reset-pw-submit': '비밀번호가 초기화되었습니다.<br>비밀번호 : koino1807!',
  'registration-access': '접근권한요청이 승인완료되었습니다.',
  'registration-reject': '접근권한요청이 반려되었습니다.',
  'registration-access-error': '반려사유 입력시 접근권한요청을 승인할 수 없습니다.',
  'registration-reject-error': '반려사유를 입력하세요.',
  'login_failed_cause_ip_reject': 'IP 제한 정책에 의해 차단되었습니다.',
  'login_failure_limit':'로그인 실패 허용횟수를 초과하였습니다.<br>담당자에게 문의 또는 메일 인증해주세요.',
  'registration-approve':'처리하기',
  'registration-reject-history':'승인내역을 반려하시겠습니까?',
  'help_ip_add':`
    <h5>IP 추가 도움말</h5><br>
    <h6 style="font-weight:bold;">
      단일 IP 추가
    </h6>
    <h6 style="padding:0 0 20px 0;">입력한 단일 IP 주소만 추가됩니다</h6>
    <h6 style="font-weight:bold;">
      IP 범위 추가
    </h6>
    <h6 style="padding:0 0 20px 0;">
      입력한 시작주소와 끝주소 사이에 포함되는 IP 주소가 추가됩니다.<br>
      예) 192.168.0.0 ~ 192.168.0.255
    </h6>
    <h6 style="font-weight:bold;">
      서브넷팅 추가
    </h6>
    <h6 style="padding:0 0 20px 0;">
      서브넷팅으로 분할된 IP 주소가 추가됩니다.<br>
      예) 192.168.32.0/24
    </h6>
    <h6 style="font-weight:bold;">
      Excel로 추가
    </h6>
    <h6 style="padding:0 0 20px 0;">
      아래 <span style="color:#38d2b8;font-weight:bold;">'Excel 양식 다운로드'</span>를 클릭하여 양식을 다운로드 받은 후
      내용을 입력하고 업로드하세요.<br><br>
      단일 IP와 subnet IP로 추가할 수 있으며,<br>
      시작주소에 IP를 입력하고, 끝주소는 비워주세요.<br><br>
      범위 IP로 추가하는 경우 시작주소와 끝주소를 입력해주세요.<br><br>
      올바르게 입력된 IP주소만 추가됩니다.
    </h6>
  `,
  'ip_range_error':'IP 주소를 확인해주세요.<br><br>',
  'ip_range_blank':'IP 주소를 입력하세요.',
  'ip_excel_no_file':'Excel 파일을 업로드해주세요.',
  'user_in_group_add':'추가할 사용자 아이디를 입력하세요',
  'user_in_group_no_exist':'존재하지 않는 사용자입니다',
  'user_in_group_overlap':'이미 그룹에 속해있는 사용자입니다',
  'user_in_group_blank':'추가할 사용자 아이디를 입력하세요',
  'user_in_group_add_success':'사용자가 그룹에 추가되었습니다',
  'user_in_group_remove_success':'사용자가 그룹에서 삭제되었습니다',
  'start_time_ch':'시작 날짜 선택',
  'start_time_time':'시작 시간 선택',
  'end_time_ch':'종료 날짜 선택',
  'end_time_time':'종료 시간 선택',
  'auth_failure_num_desc':'관리자가 설정한 횟수 이상 로그인 실패시 계정이 잠김 상태로 변경됩니다.',
  'auto_block_time':'원격 접속 후 설정한 시간 이상 사용을 안할 경우 자동으로 원격을 종료합니다.',
  'os_version_desc':'사용자의 접속 환경을 체크하여 정책 설정 상위 버전의 Windows 접속만 허용합니다.',
  'session_timie_desc':'원격 접속 후 설정한 시간 이상 초과시 자동으로 원격을 종료합니다. (사용 중에도 강제 종료)',
  'password_level_desc':'사용자를 생성할 때 비밀번호 난이도를 조정합니다.',
  'capture_desc':'중간관리자 및 사용자의 원격 화면 캡쳐 및 녹화 기능을 허용/차단합니다.',
  'display_power_save_desc':'원격 중에 원격기기 PC의 화면 절전을 방지/유지합니다.',
  'system_power_save_desc':'원격 중에 원격기기 PC의 시스템 절전을 방지/유지합니다.',
  'security_agreement_desc':'보안서약서에 동의한 사용자만 접속이 가능하도록 설정합니다.',
  'function_settings_header':'* 정책관리 : 관리자는 중간관리자 및 사용자의 원격기능 및 접속환경과 같은 일괄 적용되는 정책을 설정할 수 있습니다.',
  'vaccine_desc':'설정한 프로세스/서비스명이 실행 중인 사용자 환경에서만 접속을 허용합니다.',
  'invalid_idle_time':'원격접속 유휴시간(분)을 확인해주세요.',
  'invalid_session_time':'원격접속 유지시간(분)을 확인해주세요.',
  'invalid_block_num':'인증실패 허용횟수(회)를 확인해주세요.',
  'invalid_min_os_major':'메이저OS 버전을 확인해주세요.',
  'invalid_min_os_minor':'마이너OS 버전을 확인해주세요.',
  'password_modified_error':'기존 비밀번호를 확인해주세요.',
  'password_change_limit':'비밀번호 사용기간이 만료되었습니다.<br>비밀번호를 변경해주세요.',
  'password_expired_desc':'설정한 기간 만료시 비밀번호를 변경해야 로그인 할 수 있습니다.',
  'self_unlock_desc' : '사용자가 본인 인증을 통해 직접 계정 잠금을 해제할 수 있습니다.',
  'invalid_password_change_limit':'비밀번호 최대사용기간(일)을 확인해주세요.',
  'help_PWChangeLimit': `
    <h5>비밀번호 최대사용기간 도움말</h5><br>
    <h6 style="line-hight:1em;">
      비밀번호를 사용할 수 있는 최대 기간을 설정합니다.<br>
      최대 365일(1년)까지 설정할 수 있습니다.<br>
    </h6>
    <h6 style="padding:20px 0 0 0">
      (비밀번호 최대사용기간 미사용시 0입력)
    </h6>
  `,
  'excel_onloaded':'올바르게 작성된 하위사용자만 표시됩니다.<br>등록할 하위사용자를 선택하여 등록버튼을 눌러주세요.',
  'excel_user_submit':'실패 {failure}개를 제외한 나머지 계정정보가 일괄 등록되었습니다.',
  'excel_group_submit':'실패 {failure}개를 제외한 나머지 그룹정보가 일괄 등록되었습니다.',
  'excel_group_fail':'그룹정보 일괄등록을 실패하였습니다.<br>엑셀파일에 입력된 정보를 확인해주세요.',
  'groups':'그룹',
  'users':'사용자관리',
  'dashboard':'통계/이력',
  'payment_manage':'결제',
  'subscription': '라이선스 추가/갱신',
  'payment_history': '결제이력',
  'deleted_device_history':'원격기기 삭제 이력',
  'add_sub_user':'하위사용자 추가',
  'add_group':'그룹 추가',
  'access_time':'접속시간',
  'no_devices':'원격기기',
  'add_ip':'IP 추가',
  'delete_ip':'IP 삭제',
  'add_ip_single':'단일 IP 추가',
  'add_ip_range': 'IP 범위 추가',
  'add_ip_subnet':'서브넷팅 추가',
  'add_ip_excel':'Excel로 추가',
  'device_excel_fail': '원격기기 리스트 EXCEL 생성에 실패했습니다.',

  'mode_simple': 'SIMPLE',
  'mode_normal': 'NORMAL',
  'mode_change': '모드전환',
  'mode_change_simple': '심플모드',
  'mode_change_normal': '노멀모드',
  'icon_access': '접속가능',
  'icon_online': '온라인',
  'icon_offline': '오프라인',

  'agent_policy': '원격기기 정책',
  'agent_restart_time': '원격기기 정기 재시작 시간대 (매일)',
  'agent_restart_desc': '원격기기의 접속 유지 안정성 개선을 위한 정기 재시작 시간대를 설정합니다. 설정된 시간대에 순차적으로 원격기기가 자동 재시작 및 서버 자동 재접속됩니다. 업무에 지장이 없도록 사용량이 적은 시간대로 설정 권장합니다. 등록된 원격기기 중 원격 접속이 가능한 Online 상태의 Windows 및 Android 원격기기만 적용됩니다.',
  'agent_group_update': '원격기기 일괄 업데이트',
  'agent_group_desc': '등록된 원격기기 중 원격 접속이 가능한 Online 상태의 Windows 원격기기가 최신 버전의 원격기기로 업데이트됩니다. 업데이트는 순차적으로 적용되어 업데이트 완료 후 서버 자동 재접속됩니다.',
  'agent_update': '업데이트',
  'batch_update_desc': '최신 버전의 원격기기로 일괄 업데이트 합니다.',

  'statistics_policy' : '통계 이력 주기 설정',
  'statistics_period' : '주기',
  'day' : '일',
  'month' : '월',
  'year' : '년',

  'excel_button' : '엑셀',
  'no-agent-selected': '선택된 원격기기가 없습니다.',

  'add-group-child': '그룹 추가 _하위그룹',
  'equipment_not_registered_msg': '등록된 장비가 아닙니다.',
  'max_device_limit_reached_msg': '허용된 장치 등록 수를 모두 사용하셨습니다. <br> 추가를 원하면, 기존의 장치를 삭제해주시기 바랍니다.',
  'user_registered_agent': '본인이 등록한 원격기기',
  
  'concurrent_users': '동시접속자',
  'max_device_alert': '베이직 라이선스는 {maxDevices}개 초과 등록할 수 없습니다.',
  'min_device_alert': '코퍼레이트 라이선스는 {minDevices}개 미만 등록할 수 없습니다.',
  'min_concurrent_sessions_alert': 'LMM1000+ 라이선스는 동시접속자 {minConcurrentSessions} 이하로 등록할 수 없습니다.',
  'addLicense': '결제하기',
  'internal' : '원격 관리',
  'external' : '원격 접속',
  'payment_account_info': '<b>계좌번호:</b> 1005-101-071339<br>\n' +
    '<b>은행:</b> 우리은행<br>\n' +
    '<b>예금주:</b> ㈜ 코이노<br>\n' +
    '<small>(입금확인은 톡톡상담으로 해 주세요)</small>',
  'password_reset_email_send' : '비밀번호 재설정 메일 발송',
  'in_progress_request': '신청 중',
  
  'no_data_available': '데이터가 없습니다.',
  'agree_and_connect': '동의 및 접속',
  'decline_and_cancel': '거부 및 취소',
  'security_agreement': '보안 서약서',
  'approval_type': '결재 구분',
  'approval_line': '결재 라인',
  'application_reason': '신청 사유',
  'manual_input': '직접 입력',
  'pre_approval': '사전 결재',
  'post_approval': '사후 결재',
  'exception': '예외',
  'selection': '선택',
  'application_datetime': '신청 일시',
  'remote_device_name': '원격기기 이름',
  'delete_registered_remote_device': '등록 원격기기 삭제',
  'confirm_delete_registered_device': '아래의 등록된 원격기기를 삭제하시겠습니까?',
  'device_deletion_logout_notice': '등록 원격기기 삭제시 원격기기에서 로그아웃되며<br>자동 로그인 기능이 해제됩니다.',
  'remote_device_registration_request': '원격기기 등록 신청',
  'memo': '메모',
  'registration_datetime': '등록 일시',
  'step_n': '{n}단계',
  'apply': '적용',
  'user_kr': '유저',
  'policy_manager': '관리자',
  'mid_manager': '중간관리자',
  'admin_privileges': '관리자 권한',
  'manager_name': '매니저 이름',
  'delete_registered_manager': '등록 매니저 삭제',
  'confirm_delete_registered_manager': '아래의 등록된 매니저를 삭제하시겠습니까?',
  're_register_manager_approval_required': '삭제된 매니저를 다시 등록하시려면<br>매니저 등록 신청 결재가 필요합니다.',
  'last_login_datetime': '최종 로그인 일시',
  'add_user': '사용자 추가',
  'shared_group': '공유 그룹',
  'approval_process': '결재',
  'select_delete': '선택 삭제',
  'recording': '녹화',
  'success': '성공',
  'start_datetime': '시작 일시',
  'end_datetime': '종료 일시',
  'enter_content': '내용을 입력해 주세요.',
  'manager_str': '매니저',
  'prior': '사전',
  'post': '사후',
  'category': '구분',
  'pledge_version': '서약서 버전',
  'error_code': '에러 코드',
  'pledge': '서약서',
  'start_date_str': '시작 날짜',
  'end_date': '종료 날짜',
  'toasts_message': {
    'key_is_required': `{key}은(는) 필수 입력값입니다.`,
    'enum_error': `{key}은(는) [{allowed_values}] 값만 사용할 수 있습니다.`,
    'select_department_to_delete' : '삭제할 부서를 선택해주세요.',
    'excel_no_data' : '엑셀에 데이터가 없습니다.',
    'department_bulk_register': `실패 {failure}개를 제외한 나머지 부서정보가 일괄 등록되었습니다.`,
    'select_file': `파일을 선택해주세요.`,
    'no_data_to_download': `다운로드할 데이터가 없습니다`,
    'group_move_not_allowed': `해당 그룹은 '모든장치' 그룹입니다. 그룹 이동이 불가능합니다.`,
    'data_fetch_failed': '데이터를 가져오는데 실패하였습니다.',
    'no_data_to_download_excel': '엑셀로 다운로드 할 데이터가 없습니다.',
    'no_selected_applicants': '선택된 신청자가 없습니다.',
    'approval_completed': '결재가 완료되었습니다.',
    'no_selected_department_members': '선택된 부서 소속 인원이 없습니다.',
    'remote_device_deleted': '원격 기기가 삭제되었습니다.',
    'version_applied': '해당 버전이 적용되었습니다.',
    'save_success': '저장되었습니다.',
    'manager_deleted': '매니저가 삭제되었습니다.',
    'select_user_to_delete': '삭제할 사용자를 선택해주세요.',
    'no_department_info': '부서 정보가 없습니다.',
    'required_field_message': '{key}은(는) 필수 입력값입니다.',
    "invalid_enum_value": "{key}은(는) [{values}] 값만 사용할 수 있습니다.",
    'department_name_not_found': '존재하지 않는 부서명 입니다.',
  },
  'join_form': {
    'required_field': '필수 항목',
    'optional_field': '선택 항목'
  },
  'login_page': {
    'popup_block': '팝업 차단기가 팝업을 차단했습니다.<br>팝업 차단을 해제 후 새로고침 해주십시오.',
    'mobile_block': '일반 웹 브라우저에서는 서비스를 이용할 수 없습니다.<br>LinkMeMine 모바일 앱으로  접속해 주세요.',
    'waiting': '사용자 환경 검사와 매니저 등록 여부를 확인 중입니다.<br>환경 검사를 위한 EXE를 다운로드 및 실행하여주십시오',
    'app_download': '앱 다운로드',
    'manual_download': '수동 다운로드',
    'internal_tooltip': '원격기기를 설치 및 관리 시 사용하는 매뉴얼 다운로드',
    'external_tooltip': '원격기기가 설치된 기기를 원격접속 시 사용하는 매뉴얼 다운로드',
    'auto_login': '자동 로그인',
    'warning_massage1': '현재 로그인을 시도하는 단말기는<br><em class="text-danger">이미 등록 신청 완료 후 결재 대기 상태입니다</em>',
    'warning_massage2': '등록을 원하시는 경우 등록 신청시<br>결재자로 지정된 관리자에게 승인을 요청해주시고',
    'warning_massage3': '등록을 원하지 않으시는 경우 등록 신청시<br>결재자로 지정된 관리자에게 반려를 요청해주십시오',
    'download_android_remote_device': '안드로이드 원격기기 다운로드',
  },
  'department_page': {
    'add_department' : '부서 추가',
    'bulk_add_department' : '부서 일괄 추가',
    'department_delete' : '부서 삭제',
    'department_manage' : '부서 관리',
    'department_name' : '부서 이름',
    'department_created' : '부서를 생성했습니다.',
    'department_deleted' : '부서를 삭제했습니다.',
    'confirm_department_delete' : '해당 부서를 삭제 하시겠습니까?',
  },
  'device_page': {
    'public_access_warning': '공공장소 접속금지 경고',
    'default_group': '기본 그룹',
    'update': '업데이트',
    'device_favorite_removed': '{alias}장치의 즐겨찾기가 해제되었습니다.',
    'device_favorite_added': '{alias}장치가 즐겨찾기로 등록되었습니다.',
    'device_moved_to_group': '`{alias}장치가 {node.name}(님)의 그룹으로 이동되었습니다.`',
    'remote_device_list': '원격 기기 목록',
    'self_registration': '본인 등록',
    'remote_device_group_name': '원격 기기 그룹 이름',
    'remote_device_already_exists': '이미 존재하는 원격 기기입니다.',
    'all_devices': '모든 장치',
    'self_registered_remote_device': '본인 등록 원격 기기',
  },
  'dialogs_page': {
    'security_pledge': '보안 서약서',
    'security_pledge_desc': {
      "items": [
        "상기 본인은 지정한 근무 장소에서 원격 접속을 수행합니다.",
        "본인은 원격 접속 중 열람, 작성, 저장, 출력한 문서 또는 정보를 철저히 관리하며, 이를 외부로 유출하지 않습니다.",
        "본인은 바이러스 감염이나 유포를 방지하기 위해 원격 접속용 컴퓨터에 백신 프로그램을 설치 및 운영하며, 백신 엔진을 최신 상태로 유지합니다.",
        "본인은 원격 접속 중 컴퓨터 화면 보호 기능을 설정하고, 화면 복귀 시 반드시 비밀번호를 입력하도록 합니다.",
        "본인은 원격 접속을 위해 부여받은 아이디, 비밀번호 및 보안 정보를 철저히 관리하며 외부로 유출되지 않도록 합니다.",
        "본인이 부여받은 아이디, 비밀번호 및 보안 정보가 외부로 유출되었음을 인지한 경우 즉시 사용 정지 신청을 하고, 이를 재발급 받습니다.",
        "본인은 허가되지 않은 임의의 파일 전송, 화면 캡쳐, 녹화 등의 행위를 일절 하지 않으며, 필요시 적절한 보안 체계를 갖추고 상위 관리자에게 보고 후 수행합니다."
      ],
      "confirmation": "본인은 상기와 같은 사항을 준수하며, 이를 위반한 경우 사규 및 관련 법령에 따라 처벌 및 불이익을 감수할 것을 서약합니다."
    },
    'remote_application_form': '원격 신청서',
    'duplicate_error': '중복 에러',
    'change_start_date_and_retry': '시작일시를 변경하신 후에 다시 신청해주십시오.',
    'select_approval_line': '결재 라인을 선택해주십시오.',
    'application_info': '신청 정보',
    'registered_remote_device_info': '등록 원격기기 정보',
    'max_registration_allowed': '최대 등록 가능',
    'current_registration': '현재 등록',
    'registration_in_progress': '등록 신청중',
    'exceeded_remote_device_limit': '등록 가능한 원격기기 수량을 초과하였습니다.',
    'remove_or_revoke_pending_requests': '현재 등록된 원격기기를 삭제하거나<br>등록 신청 중인 신청/결재건을 회수하신 후<br>다시 시도하여 주십시오.',
    're_registration_requirements': '또한 삭제된 원격기기를 다시 등록하시려면 원격기기가<br>설치된 로컬에서 프로그램을 삭제 후<br>재설치/로그인/원격기기 등록신청 및 결재가 필요합니다.',
    'remote_device_registration_exceeded': '원격기기 등록 신청 초과',
    'enter_remote_device_name': '원격기기 이름을 작성해 주세요.',
    'remote_device_registration_completed': '원격기기 신청이 완료되었습니다.',
    'approver_selection': '결재자 선택',
    'approval_line_limit': '{limit}단계 결재자까지 필수 선택 후 결재 라인 반영이 가능합니다.',
    'user_environment_check_result': '사용자 환경 검사 결과',
    'inspection_item': '검사 항목',
    'description': '설명',
    'result': '결과',
    'add_selection': '선택 추가',
    'select_user_to_add': '추가할 사용자를 선택해주세요.',
    'registered_manager_info': '등록 매니저 정보',
    'manager_registration_limit_exceeded': '등록 가능한 매니저 수량을 초과하였습니다.',
    'remove_or_revoke_pending_manager_requests': '현재 등록된 매니저를 삭제하거나<br>등록 신청 중인 신청/결재건을 회수하신 후<br>다시 시도하여 주십시오.',
    'manager_registration_request': '매니저 등록 신청',
    'manager_registration_request_exceeded': '매니저 등록 신청 초과',
    'enter_manager_name': '매니저 이름을 작성해 주세요',
    'manager_registration_completed': '매니저 신청이 완료되었습니다.',
    'send_email': '메일 보내기',
  },
  'error_page': {
    'logout_completed': '로그아웃 되었습니다.',
    'invalid_access': '잘못된 접근 입니다.',
    'manager_registration_required': '미등록 매니저입니다.<br>매니저 등록 신청 팝업에서 신청해주세요.<br>팝업창이 호출되지 않으면 팝업 차단을 해제해주세요.<br>매니저 등록 신청 및 결재 승인 후<br>재접속해주세요.',
    'invalid_access_vpn': '잘못된 접근 입니다.<br>VPN 앱으로 접속하세요.',
    'session_expired': '세션이 만료되었습니다.',
    'manager_registration_success': '매니저 등록 신청이 완료되었습니다.<br>매니저 등록 신청 결재 승인 후<br>재접속해주세요.',
  },
  'groups_page': {
    'group_access_user_remote_device_list': '그룹 접근 권한 사용자가 등록한 원격기기 목록',
    'shared_group_management': '공유 그룹 관리',
    'duplicate_value_detected': '중복된 값이 있습니다: ',
    'select_group_to_delete': '삭제할 그룹을 선택해주세요.',
    'group_deletion': '그룹 삭제',
  },
  'management_page': {
    'requester': '요청자',
    'approver': '승인자',
    'delete_device': '장치 삭제',
    'enter_device_name': '장치명을 입력하세요.',
    'remote_device_registration_history': '원격기기 등록 신청 이력',
    'application_date': '신청 날짜',
    'application_time': '신청 시간',
    'approval_datetime': '결재 일시',
    'approval_status': '결재 상태',
    'approval_date': '결재 날짜',
    'approval_time': '결재 시간',
    'final_approver': '최종 결재자',
    'remote_device_registration_request_approval': '원격 기기 등록 신청 결재',
    'select_approval': '선택 결재',
    'confirm_remote_device_approval': '상기 원격 기기 등록 신청 건(들)에 대해 결재하시겠습니까?',
    'remote_device_integration_management': '원격 기기 통합 관리',
    're_registration_requirements': '삭제된 원격기기를 다시 등록하시려면<br>원격기기 등록 신청 결재가 필요합니다.',
    'registration_date': '등록 날짜',
    'registration_time': '등록 시간',
    'deletion_datetime': '삭제 일시',
    'deletion_date': '삭제 날짜',
    'deletion_time': '삭제 시간',
    'remote_device_registration_deletion_history': '원격기기 등록/삭제 이력',
    'deleter': '삭제자',
    'ip_management_policy': 'IP 관리 정책',
    'block_blacklist_ip': '(차단-블랙리스트 방식) 등록된 접속 IP를 차단',
    'block_blacklist_disabled': '(차단-블랙리스트 방식) 사용 안함',
    "start_ip_address": "IP 주소 (시작)",
    "end_ip_address": "IP 주소 (끝)",
    'approval_information': '결재 정보',
    'no_approval_information': '결재 정보가 없습니다.',
    'pending': '미결',
    'approval_opinion': '결재 의견',
    'remote_work': '재택 근무',
    'incident_response': '장애 대응',
    'dispatch': '파견',
    'maintenance': '유지 보수',
    'security_pledge_management': '보안 서약서 관리',
    'version_settings': '버전 설정',
    'enter_version': '버전을 입력해 주세요.',
    'applied_version': '적용 버전',
    'version_management': '버전 관리',
    'new_registration': '신규 등록',
    'user_remote': '사용자 원격',
    'user_remote_approval_process': '사용자 원격(결재 프로세스)',
    'user_remote_approval_policy_activation': '사용자 원격(결재 프로세스) 정책을 활성화 하여<br>사용자별 결재 프로세스 예외/적용 설정을 할 수 있습니다.',
    'approval_process_applied_policy': '결재 프로세스가 적용된 사용자의 경우,<br>반드시 원격 신청에 의한 결재 후 원격 제어가 가능합니다. (사전 결재의 경우)<br>사후 결재 권한이 있는 결재 프로세스 적용 사용자가 사후 결재로 원격 신청할 경우,<br>즉시 결재 승인된 권한을 얻어 원격 제어가 가능합니다. (사후 결재로 이력 관리)',
    'approval_process_usage': '① 사용 : 사용자별 결재 프로세스 예외/적용 설정 가능',
    'approval_process_not_applied_to_existing_exceptions': '- 사용 전환하여도 기존 결재 프로세스 예외 사용자에게 적용되지 않음',
    'approval_process_not_used': '② 미사용 : 전체 사용자 결재 프로세스 없이 원격 접속',
    'approval_process_disabled_effect': '- 미사용 전환 시 결재 프로세스 적용 사용자도 결재 없이 원격 접속 가능',
    'remote_and_connection_maintenance_policy': '원격 및 접속 유지 정책',
    'remote_and_connection_policy_applies_to_all': '원격 및 접속 유지 정책은 전체 시스템 및 사용자에게 적용됩니다.',
    'remote_control_file_transfer': '1. 원격 제어, 파일 전송',
    'block_remote_control_file_transfer': '① 차단 : 전체 사용자 원격 제어, 파일 전송 기능 차단',
    'block_applies_to_all_users': '- 차단 전환 시 기존 권한 부여된 사용자도 기능 차단',
    'allow_user_permissions': '② 허용 : 사용자별 권한 설정 가능',
    'allow_transition_no_access': '- 허용 전환하여도 기존 권한 미부여 사용자는 기능 사용 불가',
    'system_user_bulk_apply': '2. 전체 시스템 및 사용자 일괄 적용 항목',
    'screen_capture_recording_lock': '- 화면 캡쳐 및 녹화, 키보드 및 마우스 잠금, 화면 차단(블랙스크린)',
    'screen_saver_power_saving': '- 화면 보호기, 화면 절전, 전원 절전',
    'forced_idle_logout_manager': '- 강제 로그아웃(매니저), 유휴 자동 로그아웃(매니저)',
    'forced_idle_termination_viewer': '- 강제 종료(뷰어), 유휴 자동 종료(뷰어)',
    'public_access_prohibited_warning': '공공 장소 접속 금지 경고',
    'accept_and_save': '수락 및 저장',
    'windows_process_service_detection': 'Windows 프로세스 및 서비스명으로 설정한 프로세스/서비스가 동작하고 있는지를 감지하여<br>동작되고 있는 사용자 원격 접속 환경에서만 원격 접속이 가능하도록 설정합니다.',
    'add_excluding_exe': '추가 (.exe 제외)',
    'application_reason_approval_opinion_settings': '신청 사유 및 결재 의견 설정',
    'enter_application_reason': '신청 사유를 입력해 주세요',
    'enter_approval_opinion': '결재 의견을 입력해 주세요',
    'recording_storage_path_validation': '녹화 영상 스토리지 경로 검증',
    'storage_path_unreachable': '설정 하신 스토리지에 접근할 수 없거나 경로가 없습니다.',
    'storage_access_success': '설정하신 스토리지에 접근 가능합니다.',
    'windows_antivirus_check_settings': 'Windows 백신 설치/실행 확인 설정',
    'antivirus_process_name': '백신 프로세스 명<br>(.exe 제외)',
    'antivirus_process_name_excluding_exe': '백신 프로세스 명<br>(.exe 제외)',
    'antivirus_detection_by_process': '백신 설치 및 동작 여부를 Windows 프로세스명으로 감지합니다.',
    'system_policy': '시스템 정책',
    'system_policy_applies_to_all': '시스템 정책은 전체 시스템 및 사용자에게 적용됩니다.',
    'approval_process_enabled': '① 사용 : 사용자별 결재 프로세스 예외/적용 설정 가능',
    'approval_process_exception_unchanged': '- 사용 전환하여도 기존 결재 프로세스 예외 사용자에게 적용되지 않음',
    'approval_process_disabled': '② 미사용 : 전체 사용자 결재 프로세스 없이 원격 접속',
    'ip_management_enabled': '① 사용 : 관리-접속 IP 관리 메뉴 활성화, 사용자 IP로 차단/허용 가능',
    'ip_management_disabled': '② 미사용 : 관리-접속 IP 관리 메뉴 비활성화, 사용자 IP 접속 통제하지 않음',
    'connection_maintenance_policy': '접속 유지 정책',
    'forced_logout_manager': '강제 로그아웃(매니저)',
    'web_app_manager_forced_logout': 'WEB 및 APP 매니저 로그인 시 설정 시간 이후 매니저 강제 로그아웃 (설정값 0일 경우 정책 사용 안함)',
    'idle_auto_logout_manager': '유휴 자동 로그아웃(매니저)',
    'web_app_manager_idle_logout': 'WEB 및 APP 매니저 로그인 시 설정 시간 동안 동작이 없을 경우 매니저 자동 로그아웃 (설정값 0일 경우 정책 사용 안함)',
    'forced_termination_viewer': '강제 종료(뷰어)',
    'remote_connection_forced_termination': '원격 접속 시 설정 시간 이후 원격 강제 종료 (설정값 0일 경우 정책 사용 안함)',
    'idle_auto_termination_viewer': '유휴 자동 종료(뷰어)',
    'remote_connection_idle_termination': '원격 접속 시 설정 시간 동안 동작이 없을 경우 원격 자동 종료 (설정값 0일 경우 정책 사용 안함)',
    'statistics_history_cycle_settings': '통계 이력 주기 설정',
    'remote_policy': '원격 정책',
    'remote_control': '원격 제어',
    'block_allow': '차단/허용',
    'remote_control_restriction': '원격 제어 기능 차단 / 사용자별 허용 설정',
    'file_transfer_restriction': '파일 전송 기능 차단 / 사용자별 허용 설정',
    'screen_capture_recording_restriction': '화면 캡쳐 기능 및 화면 녹화 기능 차단 / 허용 설정',
    'keyboard_mouse_lock': '키보드 및 마우스 잠금',
    'not_applied_applied': '미적용/적용',
    'keyboard_mouse_lock_settings': '원격 접속 시 원격 기기 PC의 키보드 및 마우스 잠금 기능 미적용 / 적용 설정',
    'screen_block_black_screen': '화면 차단(블랙스크린)',
    'screen_block_black_screen_settings': '원격 접속 시 원격 기기 PC의 화면 차단(블랙스크린) 기능 미적용 / 적용 설정',
    'screen_saver': '화면 보호기',
    'maintain_prevent': '유지/방지',
    'screen_saver_local_settings': '원격 접속 시 원격 기기 PC의 화면 보호기 로컬 설정 유지 / 방지 설정',
    'screen_power_saving': '화면 절전',
    'screen_power_saving_local_settings': '원격 접속 시 원격 기기 PC의 화면 절전 로컬 설정 유지 / 방지 설정',
    'power_saving': '전원 절전',
    'power_saving_local_settings': '원격 접속 시 원격 기기 PC의 전원 절전 로컬 설정 유지 / 방지 설정',
    'account_security_policy': '계정 보안 정책',
    'password_complexity': '비밀번호 난이도',
    'user_remote_approval': '사용자 원격 승인',
    'disabled_enabled': '미사용/사용',
    'remote_request_and_approval': '원격 신청 및 결재 후 원격 접속 기능 사용 (사용자별 결재 프로세스 예외/적용 설정 가능)',
    'manager_registration_approval': '매니저 등록 승인',
    'manager_registration_with_approval': '매니저 등록 시 결재 후 등록 기능 사용',
    'remote_device_registration_approval': '원격 기기 등록 승인',
    'remote_device_registration_with_approval': '원격 기기 등록 시 결재 후 등록 기능 사용',
    'internal_network_admin_ip_management': '정책 관리자의 내부망 관리자 WEB 접속 IP 관리 기능 사용 (외부망 정책 관리자, 내부망 결재자, 내부망 예외 사용자, 외부망/내부망 일반 사용자는 제한하지 않음)',
    'windows_version_check': 'Windows 버전 확인',
    'windows_version_restriction': '설정된 Windows 버전 이상의 사용자 접속 환경에서만 원격 접속을 허용',
    'windows_auto_update_check': 'Windows 자동 업데이트 확인',
    'windows_auto_update_activation_check': '원격 접속 시작 시 Windows 자동 업데이트 설정 활성화 확인 후 원격 접속 허용',
    'windows_antivirus_installation_execution_check': 'Windows 백신 설치/실행 확인',
    'antivirus_installation_execution_restriction': '설정된 백신의 설치 및 실행 확인된 사용자 접속 환경에서만 원격 접속을 허용',
    'windows_process_service_check': 'Windows 프로세스/서비스 확인',
    'process_service_running_restriction': '설정된 프로세스 및 서비스가 동작 중인 사용자 접속 환경에서만 원격 접속을 허용',
    'or_higher': '이상',
    'manager_registration_request_history': '매니저 등록 신청 이력',
    'manager_registration_request_approval': '매니저 등록 신청 결재',
    'approve_manager_registration_requests': '상기 매니저 등록 신청 건(들)에 대해 결재하시겠습니까?',
    'manager_integration_management': '매니저 통합 관리',
    'manager_registration_deletion_history': '매니저 등록/삭제 이력',
    'user_remote_request_approval': '사용자 원격 신청 결재',
    'remote_request_approval': '원격 신청 결재',
    'user_remote_control_history': '사용자 원격 제어 이력',
    'remote_control_history': '원격 제어 이력',
    'remote_control_history_self': '원격 제어 이력 (본인)',
    'user_remote_request_history': '사용자 원격 신청 이력',
    'remote_request_history': '원격 신청 이력',
    'rejection_reason': '반려 사유',
    'manager_management': '매니저 관리',
    'integration_management': '통합 관리',
    'registration_request_approval': '등록 신청 결재',
    'registration_request_history': '등록 신청 이력',
    'registration_deletion_history': '등록/삭제 이력',
    'windows_process_service_check_settings': 'Windows 프로세스 / 서비스 확인 설정',
  },
  'statistics_page': {
    'development_environment': '개발 환경',
    'connection_datetime': '접속 일시',
    'connection_environment': '접속 환경',
    'user_login_history': '사용자 로그인 이력',
    'internal_network': '내부망',
    'external_network': '외부망',
    'login_date': '로그인 날짜',
    'login_time': '로그인 시간',
    'remote_control_history_statistics': '원격 제어 이력 통계',
    'remote_control_connection_count': '원격 제어 접속 횟수',
    'connection_count': '접속 횟수',
    'manager_remote_control_by_os': '매니저 OS별 원격 제어',
  },
  'support_page': {
    'remote_access_manual': '원격 접속 매뉴얼',
    'remote_management_manual': '원격 관리 매뉴얼',
    'delete_notice': '공지사항 삭제',
    'confirm_deletion': '정말 삭제하시겠습니까?',
    'author': '작성자',
    'title': '제목',
    'content': '내용',
    'register_notice': '공지사항 등록',
    'enter_title': '제목을 입력하세요',
  },
  'user_page': {
    'approver_management': '결재자 관리',
    'bulk_update': '일괄 변경',
    'not_set': '미설정',
    'step': '단계',
    'approval_step': '결재 단계',
    'no_selected_items': '선택된 항목이 없습니다.',
    're_registration_requirements': '또한 삭제된 원격 기기를 다시 등록하시려면<br>원격 기기가 설치된 로컬에서 로그인 및 원격 기기<br>등록 신청 결재가 필요합니다.',
    'no_selected_remote_device': '선택된 원격 기기가 없습니다.',
    'confirm_update_mid_manager_approval_step': '아래의 중간 관리자의 결재 단계 설정을 변경하시겠습니까?',
    'policy_manager_fixed_approval_step': "정책 관리자의 결재 단계는 '전체'로 고정되어 있어 변경 사항이 반영되지 않습니다.",
    'approval_step_update': '결재 단계 설정 변경',
    'select_approval_step': '결재 단계를 선택해 주세요.',
    'department_members': '부서 소속 인원',
    'registered_manager': '등록 매니저',
    'no_selected_manager': '선택된 매니저가 없습니다.',
    'add_department_member': '부서원 추가',
    'select_exclude': '선택 제외',
    'confirm_user_exclusion': '아래의 사용자를 {departmentName}에서 제외하시겠습니까?',
    'excluded_user_temp_department': '제외된 사용자는 무소속 부서로 임시 이동됩니다.<br>사용자의 부서 변경은 사용자 관리에서 가능합니다.',
    'exclude': '제외',
    'approval_process': '결재 프로세스',
    'department_management_department_members': '부서 관리 부서 소속 인원',
    'post_approval_permission': '사후 결재 권한',
    'department_head': '부서장',
    'bulk_apply': '일괄 적용',
    'bulk_retrieval': '일괄 회수',
    'select_department_head': '부서장 선택',
    'department_member_management': '부서원 관리',
    'members': '인원',
    'department_policy': '부서 정책',
    'registered_remote_device': '등록 원격 기기',
    'exclude_department_members': '부서 소속 인원 제외',
    'bulk_add_users': '사용자 일괄 추가',
    'enter_email': '이메일을 입력해 주세요',
    'enter_valid_email': '유효한 이메일 주소를 입력해 주세요. 최대 40자리',
    'enter_password': '비밀번호를 입력해 주세요',
    'reenter_password': '비밀번호를 다시 한번 입력해 주세요',
    'position': '직급',
    'enter_position': '직급을 입력해 주세요',
    'enter_job_title': '직책을 입력해 주세요',
    'is_department_head': '부서장 여부',
    'user_permissions': '사용자 권한',
    'self_approval_step': '본인 결재 승인 단계',
    'mandatory_approval_step_for_use_request': '사용 신청 필수 결재 단계',
    'manager_limit': '매니저 한도',
    'remote_device_limit': '원격 기기 한도',
    'file_transfer_permission': '파일 전송 권한',
    'global_settings': '전체 설정',
    'basic_user_limit': 'Basic 사용자는 하위 사용자를 1명만 생성할 수 있습니다.',
    'dev_limit_warning': '현재 계정의 최대 등록 가능 원격기기 수는 {maxValue}개 입니다. <br/> 원격기기 한도를 높이고 싶으면 결제 메뉴에서 원격기기 수를 추가 신청 하셔야 합니다.',
    'user_details': '사용자 상세',
    'apply_approval_process': '결재 프로세스 적용',
    'view_delete': '보기/삭제',
    'manager_limit_exceeded': '설정하실 등록 가능 매니저 한도가 이미 등록된 매니저 수량보다 적습니다. 등록된 매니저를 삭제하신 후에 다시 시도해주시기 바랍니다.',
    'dev_limit_exceeded': '라이선스에 등록된 원격기기 사용량({totalDevLimit}) 보다 많은 사용량을 입력했습니다.',
    'remote_device_limit_exceeded': '설정하실 등록 가능 원격 기기 한도가 이미 등록된 원격 기기 수량보다 적습니다. 등록된 원격 기기를 삭제하신 후에 다시 시도해주시기 바랍니다.',
    'work': '근무',
    'resignation': '퇴사',
    'mandatory_approval_step': '필수 결재 단계',
    'designated_approver': '지정 결재자',
    "status_changed": "{name}이(가) {status}로 변경되었습니다.",
    'registration_limit': '등록 한도',
    'concurrent_sessions_allowed': '동시 접속 허용 세션',
  },
  'access_page': {
    'unknown_error_occurred': '알 수 없는 오류가 발생하였습니다. 다시 접속을 시도하여 주십시오.',
    'screen_saver_disabled': '화면 보호기 설정이 꺼져있거나 "다시 시작할 때 로그온 화면 표시" 옵션이 꺼져 있습니다.',
    'start_required_process': '필수 구동 프로세스를 실행 후 다시 접속을 시도하여 주십시오.',
    'install_and_run_antivirus': '백신을 설치 및 실행하신 후 다시 접속을 시도하여 주십시오.',
    'enable_windows_auto_update': 'Windows 자동 업데이트 설정을 켜주시고 다시 접속을 시도하여 주십시오.',
    'comply_with_windows_policy': '사용자 접속 환경 정책의 윈도우 버전을 준수하신 후 다시 접속을 시도하여 주십시오.',
    'missing_check_program': '환경 설정 체크 프로그램을 다운받지 않은 상태입니다.',
    'check_completed': '정상 체크 완료',
    'user_environment_check_program': '사용자 환경 검사 프로그램을 다운로드 및 실행하여 주십시오.',
    'cannot_login_with_partner_id': '파트너 아이디로 로그인 할 수 없습니다.',
  },
  'environmentCheckError': {
    'unknown': "환경 체크 중 알 수 없는 오류가 발생했습니다.",
    'environmentCheckFailed': "환경 검사를 실패했습니다. <br/> 프로그램 오류 내용을 확인해주세요. ",
    'managerDevicePendingApproval': "매니저 장치가 승인 대기 상태입니다. <br/>  승인 후 변경해주세요.",
    'managerDeviceNotRegistered': "매니저 장치가 존재하지 않습니다. <br/>  매니저 장치를 등록해주세요.",
    'environmentCheckTimeout': "환경 검사 시간이 초과되었습니다. <br/>  환경 검사 프로그램을 실행시켜주세요.",
    'connectionError': "연결 중 예기치 않은 오류가 발생했습니다.",
  },
  "agent_installer_file": "에이전트 설치파일",
  "agent_file_description": "동일한 계정으로 에이전트를 설치 및 로그인까지 자동으로 진행됩니다.<br>다수의 기기에 에이전트를 설치하기에 적합합니다.",
  "install_type": "설치 형태",
  "access_account_setting": "접속 계정 설정",
  "enter_password": "비밀번호를 입력해주세요",
  "access_permission_setting": "접속 권한 설정",
  "installer_file_expiration_date": "설치 파일 만료일",
  "select_expiration_date": "만료일 선택",
  "proxy_server_setting": "프록시 서버 설정",
  "proxy_server": "프록시 서버",
  "proxy_port": "프록시 포트",
  "proxy_id": "프록시 아이디",
  "proxy_password": "프록시 비밀번호",
  "generate_installer_file": "설치 파일 생성",
  "auto_login_install_mode": "자동 로그인 설치 방식",
  "manual_login_install_mode": "수동 로그인 설치 방식",
  "disabled": "사용 안함",
  "manual_setting": "수동 설정",
  "auto_setting": "자동 설정",
  "login_failed_invalid_credentials": "로그인에 실패했습니다. 아이디 또는 비밀번호를 다시 확인해주세요.",
  "file_download_error": "파일 다운로드 중 오류가 발생했습니다.",
  "agent_auto_login_agreement_text": "링크미마인 소프트웨어 사용권 계약 및 고객지원 서비스 이용권\n\n본 소프트웨어 제품은 컴퓨터 프로그램 보호법, 저작권법, 국제저작권협약, 기타 지적재산권 법률 및 협정에 의해 보호됩니다.\n본 소프트웨어 제품은 컴퓨터 소프트웨어, 기록 매체, 인쇄물 및 온라인 문서나 전자 문서를 말하며, 본 소프트웨어 제품과 부속 문서에 수반되는 모든 실행파일, 추가 기능, 사용설명서, 도움말 파일, 기타 다른 파일이 포함되나 이에 한정되지 않습니다. 이하에서 \"사용\"이란 본 소프트웨어 제품이 컴퓨터의 주기억장치나 임시 기억장치 RAM, CD-ROM, 기타 저장장치에 저장되어 있거나 설치, 실행 또는 화면에 표시하는 행위를 말합니다.\n\n제1조 소프트웨어 사용권 및 고객지원 서비스 이용권\n\n귀하의 권리는 기본적으로 소프트웨어 자체의 사용권 및 동반된 서비스 이용권으로 구성됩니다.\n\n소프트웨어 사용권:\n귀하는 본 소프트웨어 제품을 컴퓨터에 설치해 사용할 수 있습니다.\n본 계약에 위배되는 소프트웨어 제품의 모든 복제나 재배포는 법률로 금지되며 중대한 민사 및 형사상의 처벌을 받을 수 있습니다.\n\n서비스 이용권:\n서비스라 함은 원격지 기기를 등록하고 PC나 모바일로 원격 제어 서비스를 수행하는데 있어 필요한 제반 사항을 설정하는 서비스를 말합니다.\n\n제2조 소유권\n\n본 소프트웨어 제품에 대한 특허권, 저작권, 기타 일체의 지적재산권은 주식회사 링크미마인에 있습니다. 본 소프트웨어 제품은 판매되는 것이 아니라 사용이 허가되는 것입니다. 따라서 본 소프트웨어 제품에 대한 소유권 기타 어떤 권리도 귀하에게 이전되지 않으며, 본 계약에 따른 사용권 허가는 본 소프트웨어 제품에 대한 권리의 판매로 해석되지 않습니다. 다만, 귀하가 본 사용권 계약의 조건을 준수하는 경우 백업 또는 보관 목적으로 본 소프트웨어 제품의 복사본 1본을 추가로 만들 수 있습니다. 그 이외의 경우에 귀하는 본 소프트웨어 제품의 복사본을 추가로 만들 수 없습니다. 귀하는 본 소프트웨어 제품에 부속된 인쇄물을 복사할 수 없습니다. 본 계약에 의해 명시적으로 허가되지 아니한 기타 모든 권리는 주식회사 링크미마인에 있습니다.\n\n제3조 기타 권리 및 제한에 대한 규정\n\n귀하는 관련 법규에서 허용되는 범위 이외에 본 소프트웨어 제품을 리버스 엔지니어링, 디컴파일 또는 디스어셈블할 수 없습니다. 본 계약에서 명시적으로 허용된 경우를 제외하고는 본 소프트웨어 제품의 전부 또는 일부를 사용, 복사, 번역, 재배포, 재전송, 출판, 판매, 대여, 임대, 매매, 전매, 질권설정, 담보설정, 이전, 변경, 수정 또는 확장할 수 없습니다. 귀하는 본 소프트웨어를 변형할 수 없으며, 주식회사 링크미마인의 사전 서면 동의 없이 부속된 인쇄물을 수정, 변형할 수 없습니다. 또한 귀하는 본 소프트웨어 제품을 사용해 2차 저작물을 만들 수 없습니다. 귀하는 본 소프트웨어 제품에서 소유권 인지, 마크, 라벨을 제거해서는 안됩니다.\n\n제4조 소프트웨어 제품에 대한 보증 한계\n\n보증기간: 주식회사 링크미마인는 구입한 날로부터 90일 동안 제품에 대해 물리적인 결함이 없음을 보증합니다. 보증기간 동안 제품 제작상의 실수로 결함이 발생할 시에는 교환하여 드립니다. 다만, 교환 대상은 구입일로부터 90일 이내의 제품임이 증명되어야 합니다. 사용자의 부주의나 실수, 또는 취급 소홀에 의한 손상일 경우에는 교환되지 않습니다.\n\n제한적 보증: 본 소프트웨어 제품의 사용 및 성능에 따른 모든 위험은 귀하가 부담합니다. 주식회사 링크미마인과 그 공급자들은 관련 법률이 허용하는 최대한의 범위 내에서 명시적 또는 묵시적인 모든 보증을 배제합니다. 주식회사 링크미마인은 본 소프트웨어 제품이 귀하의 요구사항을 충족시키거나 오류가 없을 것을 보증하지 않으며, 향후 OS나 하드웨어 변경에 따라 발생하는 문제에 대해 책임지지 않습니다.\n\n배타적인 구제: 주식회사 링크미마인이 부담할 모든 책임과 귀하가 받을 수 있는 배타적인 구제는 주식회사 링크미마인의 재량에 따라 (1) 결함 있는 매체의 교체 (2) 제한적 보증을 충족하지 못하는 소프트웨어 제품의 수리 또는 교체로 한정됩니다.\n\n기타 보증의 부재 및 손해배상 면책: 본 소프트웨어 사용 또는 미사용으로 인한 모든 간접적, 우연적, 결과적 손해에 대해 주식회사 링크미마인은 책임을 지지 않습니다. 손해발생 가능성을 통보받은 경우에도 동일합니다.\n\n제5조 계약 전체\n\n본 계약은 귀하와 주식회사 링크미마인 간의 전체 계약을 구성하며, 서면/구두에 관계없이 이전의 모든 계약, 고지, 설명을 대체합니다. 문의는 support@linkmemine.com 으로 연락 바랍니다.",
  "auto_install_multiple": "다수 기기 자동 설치",
  "single_agent_install": "단일 에이전트 설치",
  "license_exceeded_notice": "라이선스 초과 알림",

  // MDM (기기 정책·앱 관리)
  'mdm_page': {
    'device_policy': '기기 정책',
    'app_management': '앱 관리',
    'config_name': '구성 이름',
    'config_name_search': '구성 이름 검색',
    'add_config': '구성 추가',
    'os': 'OS',
    'all_os': '전체 OS',
    'description': '설명',
    'actions': '액션',
    'copy': '복사',
    'cannot_delete': '삭제 불가',
    'no_config': '등록된 구성이 없습니다',
    'package_id': '패키지 ID',
    'package_id_search': '패키지 ID 검색',
    'app_name': '앱 이름',
    'app_name_search': '앱 이름 검색',
    'add_app': '앱 추가',
    'install_file': '설치 파일',
    'format': '형식',
    'file_placeholder': '설치 파일 선택',
    'file_browse': '찾아보기',
    'allowed_ext': '{ext} 파일만 업로드할 수 있습니다',
    'invalid_ext': '{ext} 파일만 업로드할 수 있습니다',
    'apk_auto_extract': 'APK에서 앱 이름·패키지명·버전을 자동으로 추출합니다',
    'install_options': '설치 옵션',
    'silent_enable': '사용자 개입 없이 설치',
    'silent_select_file_first': '설치 파일을 먼저 선택하세요',
    'installer_detected_short': '{name} 감지됨',
    'installer_not_detected': '종류를 인식하지 못해 무인 설치를 사용할 수 없습니다',
    'installer_msi': 'MSI',
    'installer_nsis': 'NSIS',
    'installer_inno': 'Inno Setup',
    'installer_installshield': 'InstallShield',
    'run_after_install': '설치 후 자동 실행',
    'upload': '업로드',
    'uploading': '업로드 중...',
    'file_required': '설치 파일을 선택하세요',
    'app_name_required': '앱 이름을 입력하세요',
    'app_name_help': '설치 파일명으로 자동 입력됩니다 — 필요하면 수정하세요',
    'version_required': '버전을 입력하세요',
    'app_uploaded': '앱이 업로드되었습니다',
    'config': '구성',
    'no_app': '등록된 앱이 없습니다',
    'edit_config': '구성 수정',
    'view_config': '구성 상세',
    'os_immutable': 'OS는 생성 후 변경할 수 없습니다',
    'location_track': '위치 추적',
    'location_track_use': '기기 위치 추적 사용',
    'info_update_interval': '기기정보 보고 주기',
    'seconds': '초',
    'update_schedule': '앱 업데이트 예약 (Android 전용)',
    'update_schedule_help': '입력한 시각은 현지 시간대 기준이며 UTC로 변환되어 저장됩니다. 영업시간을 피해 설정하세요.',
    'window_start': '시작 시각',
    'window_end': '종료 시각',
    'name_required': '구성 이름을 입력하세요',
    'interval_required': '보고 주기는 1초 이상이어야 합니다',
    'schedule_time_required': '예약 시작/종료 시각을 입력하세요',
    'config_created': '구성을 생성했습니다',
    'config_updated': '구성을 수정했습니다',
    'config_copied': '구성을 복사했습니다',
    'config_deleted': '구성을 삭제했습니다',
    'copy_config': '구성 복사',
    'confirm_copy': '"{name}" 구성을 복사하시겠습니까? 정책과 앱 설정이 함께 복제됩니다.',
    'delete_config': '구성 삭제',
    'confirm_delete': '"{name}" 구성을 삭제하시겠습니까?',
    'install_policy_title': '"{app}" 설치 정책',
    'install_policy_help': '이 앱을 각 구성에 어떻게 적용할지 설정합니다.',
    'install_policy': '설치 정책',
    'all_configs': '모든 구성',
    'companywide_badge': '전체 적용',
    'state_install': '설치함',
    'state_none': '설치 안 함',
    'state_uninstall': '삭제',
    'install_policy_saved': '구성별 설치 정책을 저장했습니다',
    'delete_app': '앱 삭제',
    'confirm_delete_app': '"{name}" 앱을 삭제하시겠습니까?',
    'app_deleted': '앱을 삭제했습니다',
    'tab_settings': '설정',
    'tab_applications': '애플리케이션',
    'profile_apps_help': '이 구성에 포함할 앱과 설치 정책을 설정합니다.',
    'profile_apps_saved': '구성의 앱 설치 정책을 저장했습니다',
    'save_profile_first': '구성을 먼저 저장하면 앱을 설정할 수 있습니다',
  },
  
}
